import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BsSearch } from "react-icons/bs";
import { AiOutlineDelete } from "react-icons/ai";
import { AiFillEdit } from "react-icons/ai";
import IconButton from "@mui/material/IconButton";
import { useToast } from "../../components/ui/ToastContext";
import { FaRegCheckCircle, FaRegTimesCircle, FaEye, FaExclamationTriangle } from "react-icons/fa";
import dayjs from "dayjs";
import { jwtDecode } from 'jwt-decode';
import { IoCopy } from "react-icons/io5";
import utc from 'dayjs/plugin/utc'
import Tooltip from "@mui/material/Tooltip";
import { FaUserCheck, FaUserEdit } from "react-icons/fa";
import { MdOutlineDoneAll, MdClose } from "react-icons/md";
import { API_URL } from "../../config";
import { GrValidate } from "react-icons/gr";
import { LuCircleCheck } from "react-icons/lu";
import { LuCircleX } from "react-icons/lu";
import DatePicker from "../../components/Datapicker";
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isBetween from 'dayjs/plugin/isBetween';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../components/ui/popover";
import { BsCalendar3 } from "react-icons/bs";
import { createPortal } from 'react-dom';
import { Checkbox } from "@mui/material";
import { logAuditUI } from "../../utils/auditLogger";

dayjs.extend(utc);
dayjs.tz.guess();
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);

function DashboardCard24() {
  const { showToast } = useToast();
  const navigate = useNavigate();
  const [Data, setData] = useState([]);
  const [Data1, setData1] = useState([]);
  const [Data2, setData2] = useState([]);
  const [Data3, setData3] = useState([]);
  const [showGrid, setShowGrid] = useState(true);
  const [selecteddeleteuser, setSelecteddeleteuser] = useState(null);
  const [selecteddeleteuser1, setSelecteddeleteuser1] = useState(null);
  const [selecteddeleteuser2, setSelecteddeleteuser2] = useState(null);
  const [selecteddeleteuser3, setSelecteddeleteuser3] = useState(null);
  const [selecteddeleteuser4, setSelecteddeleteuser4] = useState(null);
  const [selectedInstitutionId, setSelectedInstitutionId] = useState(null);
  const [selectedInstitutionId1, setSelectedInstitutionId1] = useState(null);
  const [selecteduser, setSelecteduser] = useState(null);
  const [selecteduser1, setSelecteduser1] = useState(null);
  const [selecteduser2, setSelecteduser2] = useState(null);
  const [selecteduser3, setSelecteduser3] = useState(null);
  const [user, setUser] = useState(null);
  const [searchQuery1, setSearchQuery1] = useState('');
  const itemsPerPage = 15;
  const [currentPage, setCurrentPage] = useState(null);
  const [openRow, setOpenRow] = useState(null);
  const [startDate, setStartDate] = useState(dayjs().startOf('year').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(dayjs().add(1, 'month').endOf('month').format('YYYY-MM-DD'));
  const [isLoading, setIsLoading] = useState(false);
  const [isFiltering, setisFiltering] = useState(false);
  const token = localStorage.getItem('jwtToken');
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    totalCount: 0,
    totalPages: 0
  });

  const [userFilter, setUserFilter] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [showUserDropdown, setShowUserDropdown] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser(decoded);
        const savedPlanningId = Number(localStorage.getItem('selectedPlanningId'));
        const savedPlanningDayId = Number(localStorage.getItem('selectedPlanningDayId'));
        const savedSearchQuery = localStorage.getItem("SearchQ");

        if (savedPlanningId) setSelectedInstitutionId(savedPlanningId);
        if (savedPlanningDayId) setSelectedInstitutionId1(savedPlanningDayId);

        if (savedSearchQuery) {
          try {
            setSearchQuery1(JSON.parse(savedSearchQuery));
          } catch (error) {
            console.error("Invalid JSON in localStorage:", error);
          }
        }

        const handleBeforeUnload = () => {
          localStorage.removeItem('selectedPlanningId');
          localStorage.removeItem('selectedPlanningDayId');
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

      } catch (error) {
        console.error('Error decoding the token:', error);
      }
    }

  }, [token]);

  const fetchAllUsers = async () => {
    try {
      // console.log(user)
      const response = await axios.post(`${API_URL}/api/users/manageusersunic`, {
        user_id: user.userId
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      setAllUsers(response.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  // Apelă fetchAllUsers în useEffect
  useEffect(() => {
    if (user) {
      fetchAllUsers();
    }
  }, [user]);

  const fetchManageData = async () => {
    try {
      const response = await axios.post(`${API_URL}/api/totalplanning`, {
        user_id: user.userId,
        dateFrom: startDate,
        dateTo: endDate,
        page: currentPage || 1,
        pageSize: itemsPerPage,
        search: searchQuery1,
        userFilter: userFilter
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const planningData = response.data.data;
      const paginationInfo = response.data.pagination;
      const vvv = planningData.flatMap((i) => i.plannings);
      const val = vvv.map((i) => ({
        planning_id: i.planning_id,
        user_name_surname: i.user_names,
        user_id: i.user_id,
        is_validated: i.is_validated,
        start_date: i.start_date,
        end_date: i.end_date,
        date: i.created_timestamp
      }));

      setData(val);

      const nnn = vvv.flatMap((i) => i.days);
      setData1(nnn);

      const mmm = nnn.flatMap((i) => i.details);
      setData2(mmm);
      setData3(mmm.filter((i) => i.activity_type_id === 2 && i.activity_type !== null));

      setPagination(paginationInfo);
      setisFiltering(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setShowGrid(false);
    }
  };

  useEffect(() => {
    if (!user) return;
    if (currentPage > 0) {
      fetchManageData();
    }
  }, [user, currentPage, searchQuery1, startDate, endDate, userFilter]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery1, userFilter]);

  useEffect(() => {
    if (!isFiltering) return;
    fetchManageData();
  }, [isFiltering]);

  useEffect(() => {
    if (selecteddeleteuser1) {
      createreport(selecteddeleteuser1);
    }
  }, [selecteddeleteuser1]);

  useEffect(() => {
    if (selecteddeleteuser2) {
      createotherreport(selecteddeleteuser2);
    }
  }, [selecteddeleteuser2]);

  useEffect(() => {
    if (selecteddeleteuser3) {
      editreport(selecteddeleteuser3);
    }
  }, [selecteddeleteuser3]);

  useEffect(() => {
    if (selecteddeleteuser4) {
      editotherreport(selecteddeleteuser4);
    }
  }, [selecteddeleteuser4]);

  useEffect(() => {
    logAuditUI({
      actionType: 'VIEW_LIST',
      module: 'Planificare',
      description: 'A vizualizat lista de planificări',
    });
  }, []);

  const createreport = async (item) => {
    logAuditUI({
      actionType: 'OPEN_FORM',
      module: 'Raportare',
      entityId: item?.planning_id,
      description: `A deschis raportarea pentru planificarea (ID: ${item?.planning_id})`,
    });
    navigate("/planning/reportplanning", { state: { item } });
  };

  const createotherreport = async (item) => {
    logAuditUI({
      actionType: 'OPEN_FORM',
      module: 'Alte activitati',
      entityId: item?.planning_id,
      description: `A deschis raportarea altor activități pentru planificarea (ID: ${item?.planning_id})`,
    });
    navigate("/planning/reportotherplanning", { state: { item } });
  };

  const editreport = async (item) => {
    logAuditUI({
      actionType: 'OPEN_FORM',
      module: 'Raportare',
      entityId: item?.planning_id,
      description: `A deschis vizualizarea raportării (ID: ${item?.planning_id})`,
    });
    navigate("/reporting/viwereporting", { state: { item } });
  };

  const editotherreport = async (item) => {
    logAuditUI({
      actionType: 'OPEN_FORM',
      module: 'Alte activitati',
      entityId: item?.planning_id,
      description: `A deschis vizualizarea altor activități (ID: ${item?.planning_id})`,
    });
    navigate("/otheractivity/viweotheractivity", { state: { item } });
  };

  const [sortConfig, setSortConfig] = useState({
    key: 'end_date',
    direction: 'descending',
  });

  const sortedData = [...Data].sort((a, b) => {
    if (sortConfig.key && a[sortConfig.key] !== undefined && b[sortConfig.key] !== undefined) {
      const aValue = a[sortConfig.key] !== undefined ? a[sortConfig.key] : '';
      const bValue = b[sortConfig.key] !== undefined ? b[sortConfig.key] : '';

      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortConfig.direction === "ascending"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      } else if (typeof aValue === "number" && typeof bValue === "number") {
        return sortConfig.direction === "ascending" ? aValue - bValue : bValue - aValue;
      } else if (sortConfig.key === "district_name") {
        return sortConfig.direction === "ascending"
          ? new Date(aValue) - new Date(bValue)
          : new Date(bValue) - new Date(aValue);
      }
    }
    return 0;
  });

  const currentItems = sortedData;

  useEffect(() => {
    if (selecteddeleteuser) {

      deleteRow();
    }
  }, [selecteddeleteuser]);

  useEffect(() => {
    if (selecteduser) {
      handleNewRows1(selecteduser);
    }
  }, [selecteduser]);

  useEffect(() => {
    if (selecteduser1) {
      handleNewRows2(selecteduser1);
    }
  }, [selecteduser1]);

  useEffect(() => {
    if (selecteduser2) {
      handleNewRows3(selecteduser2);
    }
  }, [selecteduser2]);

  useEffect(() => {
    if (selecteduser3) {
      handleNewRows4(selecteduser3);
    }
  }, [selecteduser3]);

  const handleNewRows = (item) => {
    logAuditUI({
      actionType: 'OPEN_FORM',
      module: 'Planificare',
      description: 'A deschis formularul de adăugare planificare nouă',
    });
    navigate("/planning/createplanning");
  };

  const handleNewRows1 = (item) => {
    logAuditUI({
      actionType: 'OPEN_FORM',
      module: 'Planificare',
      entityId: item?.planning_id,
      description: `A deschis formularul de editare planificare (ID: ${item?.planning_id})`,
    });
    navigate("/planning/editplanning", { state: { item } });
  };

  const handleNewRows2 = (item) => {
    logAuditUI({
      actionType: 'OPEN_FORM',
      module: 'Planificare',
      entityId: item?.planning_id,
      description: `A deschis formularul de copiere planificare (ID: ${item?.planning_id})`,
    });
    navigate("/planning/copyplanning", { state: { item } });
  };

  const handleNewRows3 = (item) => {
    logAuditUI({
      actionType: 'OPEN_FORM',
      module: 'Planificare',
      entityId: item?.planning_id,
      description: `A deschis formularul de vizualizare planificare (ID: ${item?.planning_id})`,
    });
    navigate("/planning/viweplanning", { state: { item } });
  };

  const handleNewRows4 = (item) => {
    showToast({
      message: (
        <div>
          <p>Sigur doriți să validati această înregistrare?</p>
          <div className="flex gap-2 mt-2">
            <button
              className="px-3 py-1 bg-red-700 text-white rounded-md"
              onClick={async () => {
                await confirmDelete1();
              }}
            >
              Da
            </button>
            <button
              className="px-3 py-1 bg-gray-400 text-white rounded-md"
              onClick={() => { anulat(); setSelecteduser3("") }}
            >
              Nu
            </button>
          </div>
        </div>
      ),
      type: "warning",
      icon: <FaExclamationTriangle className="text-yellow-600 dark:text-yellow-500" />,
    });
  };

  const confirmDelete1 = async () => {
    if (selecteduser3.planning_id != null) {
      try {
        await axios.put(
          `${API_URL}/api/validateplanning`,
          {
            planning_id: selecteduser3.planning_id,
            is_validated: !selecteduser3.is_validated,
            submited_user_id: user?.userId
          }
        );
        fetchManageData();
        showToast({
          message: "Datele au fost validate cu succes!",
          type: "success",
          icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
        });
      } catch (error) {
        console.error(error);
        showToast({
          message: "Eroare la ștergerea datelor!",
          type: "error",
          icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
        });
      }
    } else {
      showToast({
        message: "ID-ul zilei de planificare este invalid.",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const deleteRow = async () => {
    showToast({
      message: (
        <div>
          <p>Sigur doriți să ștergeți această înregistrare?</p>
          <div className="flex gap-2 mt-2">
            <button
              className="px-3 py-1 bg-red-700 text-white rounded-md"
              onClick={async () => {
                await confirmDelete();
              }}
            >
              Da
            </button>
            <button
              className="px-3 py-1 bg-gray-400 text-white rounded-md"
              onClick={() => { anulat(); setSelecteddeleteuser("") }}
            >
              Nu
            </button>
          </div>
        </div>
      ),
      type: "warning",
      icon: <FaExclamationTriangle className="text-yellow-600 dark:text-yellow-500" />,
    });
  };

  const anulat = async () => {
    showToast({
      message: "Anulat",
      type: "success",
      icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      duration: 20
    });
  };

  const confirmDelete = async () => {
    if (selecteddeleteuser.planning_id != null) {
      try {
        await axios.put(
          `${API_URL}/api/deleteplanning`,
          {
            planning_id: selecteddeleteuser.planning_id,
            submited_user_id: user?.userId
          }
        );
        fetchManageData();
        showToast({
          message: "Datele au fost șterse cu succes!",
          type: "success",
          icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
        });
      } catch (error) {
        console.error(error);
        showToast({
          message: "Eroare la ștergerea datelor!",
          type: "error",
          icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
        });
      }
    } else {
      showToast({
        message: "ID-ul zilei de planificare este invalid.",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const scrollRef = useRef(null);

  const handleScroll = useCallback(() => {
    if (scrollRef.current) {
      const scrollTop = scrollRef.current.scrollTop;
      localStorage.setItem('tableScrollPos', scrollTop.toString());
    }
  }, []);

  useEffect(() => {
    if (sortedData.length && scrollRef.current) {
      const savedScroll = localStorage.getItem('tableScrollPos');
      if (savedScroll) {
        scrollRef.current.scrollTop = parseInt(savedScroll, 10);
      }
    }
  }, [sortedData]);

  useEffect(() => {
    const div = scrollRef.current;

    const savedScroll = localStorage.getItem('tableScrollPos');
    if (savedScroll && div) {
      const scrollTop = parseInt(savedScroll, 10);
      const interval = setInterval(() => {
        if (div.scrollHeight > scrollTop) {
          div.scrollTop = scrollTop;
          clearInterval(interval);
        }
      }, 50);
    }

    if (div) {
      div.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (div) {
        div.removeEventListener('scroll', handleScroll);
      }
    };
  }, [handleScroll]);

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const handlePageChange = (newPage) => {
    const validPage = Math.max(1, Math.min(newPage, pagination.totalPages));
    setCurrentPage(validPage);
  };


  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const buttonRef = useRef();

  const updateDropdownPosition = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + window.scrollY + 5,
        left: rect.left + window.scrollX
      });
    }
  };

  const handleButtonClick = () => {
    updateDropdownPosition();
    setShowUserDropdown(!showUserDropdown);
  };

  // Actualizează poziția când scroll-ezi sau resize
  useEffect(() => {
    if (showUserDropdown) {
      const handleScrollResize = () => updateDropdownPosition();
      window.addEventListener('scroll', handleScrollResize);
      window.addEventListener('resize', handleScrollResize);
      return () => {
        window.removeEventListener('scroll', handleScrollResize);
        window.removeEventListener('resize', handleScrollResize);
      };
    }
  }, [showUserDropdown]);

  return (
    <div>
      {showGrid ? (
        <div className="flex flex-row gap-2">
          <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
          <div className="flex flex-col gap-2">
            <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
          </div>
        </div>
      ) : (
        <div className="col-span-full xl:col-span-8 bg-white dark:bg-gray-800 shadow-sm rounded-xl ">
          <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60 ">
            <div className="lg:flex lg:items-center lg:justify-between d-flex flex-column flex-md-row justify-content-between align-items-start">
              <h2 className=" font-bold text-gray-800 dark:text-gray-100 mb-4 sm:mb-0 md:mb-0">Planificare</h2>
              <div className="sm:flex sm:items-center sm:gap-4 w-full sm:w-auto md:flex md:items-center md:gap-4 md:w-auto">
                <Popover>
                  <PopoverTrigger asChild>
                    <button className="btn bg-white text-gray-900 border border-solid border-gray-300 hover:bg-gray-200 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-gray-700 dark:hover:text-gray-100"
                    >
                      <BsCalendar3 className="w-4 h-4 mr-3 text-gray-700" />
                      <span>Filtrare dupa data</span>
                    </button>
                  </PopoverTrigger>
                  <PopoverContent className="w-96 p-6" align="start">
                    <div className="space-y-4">
                      <div className="relative">
                        <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100">
                          Perioada: De la..
                        </label>
                        <DatePicker
                          selectedDate={startDate}
                          handleDateChange={handleStartDateChange}
                          className="w-full"
                          toDate={dayjs(endDate).toDate()}
                        />
                      </div>

                      <div className="relative">
                        <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100">
                          Perioada: Pana la..
                        </label>
                        <DatePicker
                          selectedDate={endDate}
                          handleDateChange={handleEndDateChange}
                          className="w-full"
                          fromDate={dayjs(startDate).toDate()}
                        />
                      </div>
                    </div>
                    <div className="mt-6 flex justify-end gap-3">
                      <button
                        className={`btn ${isLoading
                          ? "bg-gray-500 text-gray-300"
                          : "bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"}`}
                        onClick={() => setisFiltering(true)}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <svg
                            className="animate-spin fill-current shrink-0 xs:hidden"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                          >
                            <circle
                              className="opacity-25"
                              cx="8"
                              cy="8"
                              r="7"
                              stroke="currentColor"
                              strokeWidth="2" />
                            <path
                              className="opacity-75"
                              d="M12 2a6 6 0 000 12V2z" />
                          </svg>
                        ) : (
                          <svg
                            className="fill-current shrink-0 xs:hidden"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                          >
                            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                          </svg>
                        )}
                        <span className="//max-xs:sr-only">
                          {isLoading ? "Filtrare..." : "Filtreaza"}
                        </span>
                      </button>
                    </div>
                  </PopoverContent>
                </Popover>

                <div className="relative w-full sm:w-64 md:w-80">
                  <BsSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    className="pl-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 focus:border-blue-500 focus:outline-none dark:bg-gray-800 dark:text-gray-200 "
                    placeholder="Căutare"
                    value={searchQuery1}
                    onChange={(e) => {
                      setSearchQuery1(e.target.value);
                      localStorage.setItem("SearchQ", JSON.stringify(e.target.value));
                    }} />
                </div>

                <button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white mt-4 sm:mt-0"
                  onClick={() => handleNewRows()}
                >
                  <span className="//max-xs:sr-only">Adauga</span>
                </button>
              </div>
            </div>
          </header>

          <div className="p-3" >
            <div
              className="overflow-y-auto"
            >
              <table className="table-auto w-full dark:text-gray-300">
                <thead className="text-xs uppercase text-gray-400 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                  <tr>
                    <th className="p-2 hidden md:table-cell">
                      <div className="font-semibold text-left">Data crearii</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-left">
                        <div className="flex items-center gap-2">
                          <span>Utilizator</span>
                          {user?.role !== "User" && (
                            <div className="relative" >
                              <button
                                ref={buttonRef}
                                onClick={handleButtonClick}
                                className="flex items-center gap-1 p-1 rounded hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
                              >
                                <svg
                                  className="w-4 h-4 text-gray-500"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.207A1 1 0 013 6.5V4z"
                                  />
                                </svg>
                              </button>
                            </div>
                          )}
                          {userFilter.length > 0 && (
                            <button className="text-xs bg-blue-500 text-white w-5 h-5 rounded-full flex items-center justify-center" onClick={() => setUserFilter([])}>
                              {userFilter.length}
                            </button>
                          )}
                        </div>
                      </div>

                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-left">Perioada</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-center">Validat</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-center">Actiune</div>
                    </th>
                  </tr>
                </thead>
                <tbody className="text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60">
                  {currentItems.map((customer, index) => {
                    const institutionIds = Data
                      .filter((i) => i.planning_id === customer.planning_id)
                      .map((i) => i.planning_id);
                    const filteredAdress = Data1.filter((i) => institutionIds.includes(i.planning_id));
                    const isSelected = Number(selectedInstitutionId) === customer.planning_id;
                    const filteredAdress1 = Data2.filter((i) => i.planning_day_id === selectedInstitutionId1 && i.obiect_type_id !== null);
                    const isSelected1 = selectedInstitutionId1;
                    const val = Data3.map((i) => i.planning_detail_id);
                    const filteredAdress2 = Data2.filter((i) => i.planning_day_id === selectedInstitutionId1 && i.activity_type_id === 2 && val.includes(i.planning_detail_id));
                    return (
                      <React.Fragment key={customer.planning_id}>
                        <tr
                          role="button"
                          className={`${index % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"} hover:bg-gray-200 dark:hover:bg-gray-600`}
                        >
                          <td className="p-2 whitespace-nowrap xs:text-wrap hidden md:table-cell"
                            onClick={(e) => {
                              e.stopPropagation();

                              const planningId = isSelected ? null : customer.planning_id;
                              const planningDayId = Data1
                                .sort((a, b) => dayjs(a.date).unix() - dayjs(b.date).unix())
                                .find((i) => i.planning_id === customer.planning_id)?.planning_day_id;

                              setSelectedInstitutionId(planningId);
                              setSelectedInstitutionId1(planningDayId);

                              localStorage.setItem('selectedPlanningId', planningId);
                              localStorage.setItem('selectedPlanningDayId', planningDayId);
                            }}

                          >
                            <div className="text-left"> {customer.date && dayjs.utc(customer.date).format("DD-MM-YYYY")}</div>
                          </td>
                          <td className="p-2 whitespace-nowrap xs:text-wrap"
                            onClick={(e) => {
                              e.stopPropagation();

                              const planningId = isSelected ? null : customer.planning_id;
                              const planningDayId = Data1
                                .sort((a, b) => dayjs(a.date).unix() - dayjs(b.date).unix())
                                .find((i) => i.planning_id === customer.planning_id)?.planning_day_id;

                              setSelectedInstitutionId(planningId);
                              setSelectedInstitutionId1(planningDayId);

                              localStorage.setItem('selectedPlanningId', planningId);
                              localStorage.setItem('selectedPlanningDayId', planningDayId);
                            }}
                          >
                            <div className="text-left">{customer.user_name_surname}</div>
                          </td>
                          <td className="p-2 whitespace-nowrap xs:text-wrap"
                            onClick={(e) => {
                              e.stopPropagation();

                              const planningId = isSelected ? null : customer.planning_id;
                              const planningDayId = Data1
                                .sort((a, b) => dayjs(a.date).unix() - dayjs(b.date).unix())
                                .find((i) => i.planning_id === customer.planning_id)?.planning_day_id;

                              setSelectedInstitutionId(planningId);
                              setSelectedInstitutionId1(planningDayId);

                              localStorage.setItem('selectedPlanningId', planningId);
                              localStorage.setItem('selectedPlanningDayId', planningDayId);
                            }}
                          >
                            <div className="text-left"> {customer.start_date && dayjs.utc(customer.start_date).format("DD-MM-YYYY")} - {customer.end_date && dayjs.utc(customer.end_date).format("DD-MM-YYYY")}</div>
                          </td>
                          <td
                            className="p-2 whitespace-nowrap h-full"
                            onClick={(e) => {
                              e.stopPropagation();

                              const planningId = isSelected ? null : customer.planning_id;
                              const planningDayId = Data1
                                .sort((a, b) => dayjs(a.date).unix() - dayjs(b.date).unix())
                                .find((i) => i.planning_id === customer.planning_id)?.planning_day_id;

                              setSelectedInstitutionId(planningId);
                              setSelectedInstitutionId1(planningDayId);

                              localStorage.setItem('selectedPlanningId', planningId);
                              localStorage.setItem('selectedPlanningDayId', planningDayId);
                            }}
                          >
                            <div
                              className={`flex items-center justify-center font-semibold ${customer.is_validated ? 'text-green-500' : 'text-red-500'}`}
                              style={{
                                fontWeight: "bold",
                                fontSize: "20px",
                                height: "100%",
                              }}
                            >
                              {customer.is_validated ? <LuCircleCheck size={20} /> : <LuCircleX size={20} />}
                            </div>
                          </td>
                          <td>
                            <div className="font-semibold text-center"
                              style={{
                                fontWeight: "bold",
                                fontSize: "20px"
                              }}
                            >
                              <Tooltip title="Editeaza" arrow placement="top">
                                <IconButton
                                  onClick={() => setSelecteduser(customer)}
                                  color="primary"
                                  disabled={customer.is_validated}
                                  sx={{
                                    fontSize: "16px",
                                    borderRadius: "50%",
                                    "&:hover": {
                                      backgroundColor: "#a4adad",
                                    },
                                    "&.Mui-disabled": {
                                      visibility: "hidden",
                                      color: "rgba(0, 0, 0, 0.09)",
                                      backgroundColor: "rgba(255, 255, 255, 0)",
                                    },
                                  }}
                                >
                                  <AiFillEdit className=" dark:text-gray-100" />
                                </IconButton>
                              </Tooltip>

                              <Tooltip title="Sterge" arrow placement="top">
                                <IconButton
                                  onClick={() => setSelecteddeleteuser(customer)}
                                  color="primary"
                                  sx={{
                                    fontSize: "16px",
                                    borderRadius: "50%",
                                    "&:hover": {
                                      backgroundColor: "#a4adad",
                                    },
                                  }}
                                >
                                  <AiOutlineDelete className=" dark:text-gray-100" />
                                </IconButton>
                              </Tooltip>

                              <Tooltip title="Copiaza" arrow placement="top">
                                <IconButton
                                  onClick={() => setSelecteduser1(customer)}
                                  color="primary"
                                  sx={{
                                    fontSize: "16px",
                                    borderRadius: "50%",
                                    "&:hover": {
                                      backgroundColor: "#a4adad",
                                    },
                                  }}
                                >
                                  <IoCopy className=" dark:text-gray-100" />
                                </IconButton>
                              </Tooltip>

                              <Tooltip title="Vizualizeaza" arrow placement="top">
                                <IconButton
                                  onClick={() => setSelecteduser2(customer)}
                                  color="primary"
                                  sx={{
                                    fontSize: "16px",
                                    borderRadius: "50%",
                                    "&:hover": {
                                      backgroundColor: "#a4adad",
                                    },
                                  }}
                                >
                                  <FaEye className=" dark:text-gray-100" />
                                </IconButton>
                              </Tooltip>

                              {user && user.role !== 'User' && (
                                <Tooltip title="Validare" arrow placement="top">
                                  <IconButton
                                    onClick={() => setSelecteduser3(customer)}
                                    color="primary"
                                    sx={{
                                      fontSize: "16px",
                                      borderRadius: "50%",
                                      "&:hover": {
                                        backgroundColor: "#a4adad",
                                      },
                                    }}
                                  >
                                    <GrValidate className=" dark:text-gray-100" />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </div>
                          </td>
                        </tr>

                        {isSelected && (
                          <tr className="bg-gray-50 dark:bg-gray-800">
                            <td colSpan="5" className="p-2">
                              <div className="flex gap-4 flex-col sm:flex-row">
                                <div className="w-1/5 max-xs:w-full">
                                  <table className="w-full table-fixed border border-gray-300 dark:border-gray-600">
                                    <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                                      <tr>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Data</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Numarul de vizite</div>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {filteredAdress.sort((a, b) => dayjs(a.date).unix() - dayjs(b.date).unix()).map((item, idx) => (
                                        <tr
                                          role="button"
                                          key={idx}
                                          className={`border border-gray-300 dark:border-gray-600 ${item.planning_day_id === selectedInstitutionId1 ? 'bg-violet-200 dark:bg-violet-700' : ''}`}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            const planningDayId = item.planning_day_id;
                                            setSelectedInstitutionId1(planningDayId);
                                            localStorage.setItem('selectedPlanningDayId', planningDayId);
                                          }}
                                        >
                                          <td className="p-2 whitespace-nowrap">
                                            <div className="text-left">{dayjs.utc(item.date).format("DD-MM-YYYY")}</div>
                                          </td>
                                          <td className="p-2 whitespace-nowrap">
                                            <div className="text-center">{item.details?.length}</div>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>

                                {isSelected1 && (
                                  <div className="w-4/5 xs:w-full max-xs:max-h-[50vh] overflow-y-auto" ref={scrollRef}
                                    onScroll={handleScroll} >
                                    {filteredAdress1.length > 0 ? (
                                      <><h2 className="font-semibold text-gray-700 dark:text-gray-200">Vizite</h2>
                                        <div className=" max-xs:sr-only">
                                          <table className="w-full border border-gray-300 dark:border-gray-600">
                                            <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                                              <tr>
                                                <th className="p-2">
                                                  <div className="font-semibold text-left">Doctor</div>
                                                </th>
                                                <th className="p-2">
                                                  <div className="font-semibold text-left">Specialitatea</div>
                                                </th>
                                                <th className="p-2">
                                                  <div className="font-semibold text-left">Tip</div>
                                                </th>
                                                <th className="p-2">
                                                  <div className="font-semibold text-left">Institutia</div>
                                                </th>
                                                <th className="p-2">
                                                  <div className="font-semibold text-left">Adresa</div>
                                                </th>
                                                <th className="p-2">
                                                  <div className="font-semibold text-left">Oras</div>
                                                </th>
                                                <th className="p-2">
                                                  <div className="font-semibold text-left">Vizita Dubla</div>
                                                </th>
                                                <th className="p-2">
                                                  <div className="font-semibold text-left">Actiune</div>
                                                </th>

                                              </tr>
                                            </thead>
                                            <tbody>
                                              {filteredAdress1.map((item, idx) => (
                                                <tr key={idx} className="border border-gray-300 dark:border-gray-600">
                                                  <td className="p-2 //whitespace-nowrap">
                                                    <div className="text-left">
                                                      {item.obiect_type_id === 1 ? (
                                                        <div className="flex items-center gap-1.5">
                                                          <span>{item.physician?.name || item.physician}</span>
                                                          {(item.physician?.data_acord || item.data_acord) ? (
                                                            <span title="Acord marketing confirmat" className="inline-flex items-center text-emerald-500 flex-shrink-0">
                                                              <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                              </svg>
                                                            </span>
                                                          ) : null}
                                                        </div>
                                                      ) : "-"}
                                                    </div>
                                                  </td>
                                                  <td className="p-2 //whitespace-nowrap">
                                                    <div className="text-left">
                                                      {item.obiect_type_id === 1 ?
                                                        item.physician?.speciality
                                                        : "-"}
                                                    </div>
                                                  </td>
                                                  <td className="p-2 //whitespace-nowrap">
                                                    <div className="text-left">
                                                      {item.location?.inst_type || "Nu exista institutie"}
                                                    </div>
                                                  </td>
                                                  <td className="p-2 //whitespace-nowrap">
                                                    <div className="text-left">
                                                      {item.location?.institution || "Nu exista institutie"}
                                                    </div>
                                                  </td>
                                                  <td className="p-2 //whitespace-nowrap">
                                                    <div className="text-left">
                                                      {item.location?.address || "Nu exista institutie"}
                                                    </div>
                                                  </td>
                                                  <td className="p-2 //whitespace-nowrap">
                                                    <div className="text-left">
                                                      {item.location?.city || "Nu exista institutie"}
                                                    </div>
                                                  </td>
                                                  <td className="p-2 //whitespace-nowrap">
                                                    <div className="text-left">
                                                      <Checkbox
                                                      disabled={true}
                                                        checked={item.is_double_visit || false}
                                                        sx={{
                                                          color: item.is_double_visit ? "#10b981" : "#9ca3af",
                                                          '&.Mui-checked': {
                                                            color: "#10b981",
                                                          },
                                                          '&:hover': {
                                                            backgroundColor: "rgba(16, 185, 129, 0.1)",
                                                          },
                                                          padding: "4px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                  <td>
                                                    <div
                                                      className="font-semibold text-right"
                                                      style={{
                                                        fontWeight: "bold",
                                                        fontSize: "20px",
                                                      }}
                                                    >

                                                      {
                                                        item.report_detail_id !== null
                                                          ? (
                                                            <div className="flex items-center space-x-2">
                                                              <Tooltip title={"Raportat"} arrow placement="top">
                                                                <MdOutlineDoneAll className="text-green-700 text-xl" />
                                                              </Tooltip>
                                                              <Tooltip title={"Vizualizeaza"} arrow placement="top">
                                                                <IconButton
                                                                  onClick={() => setSelecteddeleteuser3(item)}
                                                                  color="primary"
                                                                  sx={{
                                                                    fontSize: "16px",
                                                                    borderRadius: "50%",
                                                                    "&:hover": {
                                                                      backgroundColor: `#a4adad`,
                                                                    },
                                                                  }}
                                                                >
                                                                  <FaUserEdit className="dark:text-gray-100" />
                                                                </IconButton>
                                                              </Tooltip>
                                                            </div>
                                                          ) : (
                                                            <div className="flex items-center space-x-2">
                                                              <Tooltip title={"Neraportat"} arrow placement="top">
                                                                <MdClose className="text-red-700 text-xl" />
                                                              </Tooltip>
                                                              <Tooltip title="Raporteaza" arrow placement="top">
                                                                <IconButton
                                                                  onClick={() => setSelecteddeleteuser1(item)}
                                                                  color="primary"
                                                                  sx={{
                                                                    fontSize: "16px",
                                                                    borderRadius: "50%",
                                                                    "&:hover": {
                                                                      backgroundColor: "#a4adad",
                                                                    },
                                                                  }}
                                                                >
                                                                  <FaUserCheck className="dark:text-gray-100" />
                                                                </IconButton>
                                                              </Tooltip>
                                                            </div>
                                                          )}
                                                    </div>
                                                  </td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        </div>

                                        <div className="sm:hidden mb-4">
                                          <table className="w-full">
                                            <tbody>
                                              {filteredAdress1.map((item, idx) => {
                                                const isReported = item.report_detail_id !== null
                                                return (
                                                  <tr key={item.planning_detail_id || idx}>
                                                    <td>
                                                      <React.Fragment>
                                                        <button
                                                          className="sm:hidden mb-4 p-3 rounded-lg bg-gray-100 dark:bg-gray-700 w-full text-left hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                          onClick={() => isReported ? setSelecteddeleteuser3(item) : setSelecteddeleteuser1(item)}
                                                        >

                                                          <div className="grid grid-cols-1 gap-2">
                                                            <div className="flex items-center gap-2 p-2">
                                                              <div>
                                                                <h3 className="text-gray-900 dark:text-gray-100 flex items-center gap-1.5">
                                                                  {item.obiect_type_id === 1 ? (
                                                                    <>
                                                                      <span>{item.physician?.name || item.physician}</span>
                                                                      {(item.physician?.data_acord || item.data_acord) ? (
                                                                        <span title="Acord marketing confirmat" className="inline-flex items-center text-emerald-500 flex-shrink-0">
                                                                          <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                                          </svg>
                                                                        </span>
                                                                      ) : null}
                                                                    </>
                                                                  ) : (
                                                                    item.location?.institution
                                                                  )}
                                                                </h3>

                                                                <div className="text-md text-gray-500 dark:text-gray-400">
                                                                  {item.location?.inst_type || "Nu exista institutie"}
                                                                </div>

                                                                <div className="text-md text-gray-500 dark:text-gray-400">
                                                                  {item.obiect_type_id === 1 ?
                                                                    item.physician?.speciality + " - " + item.location?.institution
                                                                    : null}
                                                                </div>

                                                                <div className="text-md text-gray-500 dark:text-gray-400">
                                                                  {item.location?.address + " - " + item.location?.city}
                                                                </div>
                                                              </div>
                                                            </div>

                                                            <div className="flex justify-end items-center">
                                                              <div
                                                                className="font-semibold text-right"
                                                                style={{
                                                                  fontWeight: "bold",
                                                                  fontSize: "20px",
                                                                }}
                                                              >

                                                                {
                                                                  item.report_detail_id !== null
                                                                    ? (
                                                                      <div className="flex items-center space-x-2">
                                                                        <Tooltip title={"Raportat"} arrow placement="top">
                                                                          <MdOutlineDoneAll className="text-green-700 text-xl" />
                                                                        </Tooltip>
                                                                        <Tooltip title={"Raportat"} arrow placement="top">
                                                                          <FaUserEdit className="dark:text-gray-100" />
                                                                        </Tooltip>
                                                                      </div>
                                                                    ) : (
                                                                      <div className="flex items-center space-x-2">
                                                                        <Tooltip title={"Neraportat"} arrow placement="top">
                                                                          <MdClose className="text-red-700 text-xl" />
                                                                        </Tooltip>
                                                                        <Tooltip title={"Neraportat"} arrow placement="top">
                                                                          <FaUserCheck className="dark:text-gray-100 text-md" />
                                                                        </Tooltip>
                                                                      </div>
                                                                    )}
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </button>
                                                      </React.Fragment>
                                                    </td>
                                                  </tr>
                                                );
                                              })}
                                            </tbody>
                                          </table>
                                        </div>
                                      </>
                                    ) : ("")}

                                    {filteredAdress2.length > 0 ? (
                                      <div className="mt-4">
                                        <h2 className="font-semibold text-gray-700 dark:text-gray-200 " >Alte activitati</h2>
                                        <table className="w-full border border-gray-300 dark:border-gray-600 max-xs:sr-only">
                                          <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                                            <tr>
                                              <th className="p-2">
                                                <div className="font-semibold text-left">Activitatea</div>
                                              </th>
                                              <th className="p-2">
                                                <div className="font-semibold text-left">Interval ora</div>
                                              </th>
                                              <th className="p-2">
                                                <div className="font-semibold text-left">Tip</div>
                                              </th>
                                              <th className="p-2">
                                                <div className="font-semibold text-left">Institutia</div>
                                              </th>
                                              <th className="p-2">
                                                <div className="font-semibold text-left">Specialitatea</div>
                                              </th>
                                              <th className="p-2">
                                                <div className="font-semibold text-left">Numar. pers.</div>
                                              </th>
                                              <th className="p-2">
                                                <div className="font-semibold text-left">Comentariu</div>
                                              </th>

                                              <th className="p-2">
                                                <div className="font-semibold text-center">Actiune</div>
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {filteredAdress2.map((item, idx) => {
                                              const matchingInst = Data3.find((i) => i.planning_detail_id === item.planning_detail_id)?.other_activity_detail_id;

                                              return (
                                                <React.Fragment key={item.planning_detail_id}>
                                                  <tr key={item.planning_detail_idd} className="border border-gray-300 dark:border-gray-600">
                                                    <td className="p-2 ">
                                                      <div className="text-left">
                                                        {item.activity_type}
                                                      </div>
                                                    </td>
                                                    <td className="p-2 //whitespace-nowrap">
                                                      <div className="text-left">
                                                        {
                                                          item.start_time && item.end_time && dayjs(item.start_time).isValid() && dayjs(item.end_time).isValid()
                                                            ? (<span>{dayjs.utc(item.start_time).format('HH:mm')} - {dayjs.utc(item.end_time).format('HH:mm')}</span>) : (
                                                              <span>{item.start_time} - {item.end_time}</span>)
                                                        }
                                                      </div>
                                                    </td>
                                                    <td className="p-2 ">
                                                      {item.location?.inst_type || "Nu exista institutie"}
                                                    </td>
                                                    <td className="p-2">
                                                      {
                                                        item.location?.institution ? (item.location?.institution + " - " + item.location?.address + " - " + item.location?.city) : "Nu exista institutie"
                                                      }
                                                    </td>
                                                    <td className="p-2 //whitespace-nowrap">
                                                      {item.activity?.speciality || "Nu exista specialitate"}
                                                    </td>
                                                    <td className="p-2 //whitespace-nowrap">
                                                      {item.persons}
                                                    </td>
                                                    <td className="p-2 //whitespace-nowrap text-blue-500 underline cursor-pointer" onClick={() => setOpenRow(openRow === matchingInst ? null : matchingInst)}>Afiseaza</td>
                                                    <td>
                                                      <div
                                                        className="font-semibold text-center"
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize: "20px",
                                                        }}
                                                      >
                                                        {
                                                          item.report_detail_id !== null ? (
                                                            <div className="flex items-center space-x-2">
                                                              <Tooltip title={"Raportat"} arrow placement="top">
                                                                <MdOutlineDoneAll className="text-green-700 text-xl" />
                                                              </Tooltip>

                                                              <Tooltip title={"Vizualizeaza"} arrow placement="top">
                                                                <IconButton
                                                                  onClick={() => setSelecteddeleteuser4(item)}
                                                                  color="primary"
                                                                  sx={{
                                                                    fontSize: "16px",
                                                                    borderRadius: "50%",
                                                                    "&:hover": {
                                                                      backgroundColor: `#a4adad`,
                                                                    },
                                                                  }}
                                                                >
                                                                  <FaUserEdit className="dark:text-gray-100" />
                                                                </IconButton>
                                                              </Tooltip></div>
                                                          ) : (
                                                            <div className="flex items-center space-x-2">
                                                              <Tooltip title={"Neraportat"} arrow placement="top">
                                                                <MdClose className="text-red-700 text-xl" />
                                                              </Tooltip>

                                                              <Tooltip title={"Raporteaza"} arrow placement="top">
                                                                <IconButton
                                                                  onClick={() => setSelecteddeleteuser2(item)}
                                                                  color="primary"
                                                                  sx={{
                                                                    fontSize: "16px",
                                                                    borderRadius: "50%",
                                                                    "&:hover": {
                                                                      backgroundColor: `#a4adad`,
                                                                    },
                                                                  }}
                                                                >
                                                                  <FaUserCheck className="dark:text-gray-100" />
                                                                </IconButton>
                                                              </Tooltip>
                                                            </div>
                                                          )}
                                                      </div>
                                                    </td>
                                                  </tr>
                                                  {openRow === matchingInst && (
                                                    <tr className="bg-gray-50 dark:bg-gray-800">
                                                      <td colSpan="11" className="p-4">
                                                        <div className="text-sm text-gray-800 dark:text-gray-200 flex justify-between">
                                                          <div className="flex gap-1">
                                                            <strong>Comentariu:</strong>
                                                            <span style={{ width: '90%', display: 'block', wordWrap: 'break-word' }}>
                                                              {item.comment || 'Nu exista comentariu.'}
                                                            </span>
                                                          </div>
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  )}
                                                </React.Fragment>
                                              );
                                            })}
                                          </tbody>
                                        </table>

                                        <table className="w-full">
                                          <tbody >
                                            {filteredAdress2.map((item, idx) => {
                                              const isReported = item.report_detail_id !== null
                                              return (
                                                <tr key={item.planning_detail_id || idx}>
                                                  <td>
                                                    <React.Fragment>
                                                      <button
                                                        className="sm:hidden mb-4 p-3 rounded-lg bg-gray-100 dark:bg-gray-700 w-full text-left hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                        onClick={() => isReported ? setSelecteddeleteuser4(item) : setSelecteddeleteuser2(item)}
                                                      >
                                                        <div className="grid grid-cols-1 gap-2">
                                                          <div className="font-medium">
                                                            <span className="text-gray-600 dark:text-gray-300">Activitate: </span>
                                                            {item.activity_type}
                                                          </div>

                                                          <div className="flex items-center">
                                                            <span className="text-gray-600 dark:text-gray-300">Interval ora: </span>
                                                            {
                                                              item.start_time && item.end_time && dayjs(item.start_time).isValid() && dayjs(item.end_time).isValid()
                                                                ? (<span>{dayjs.utc(item.start_time).format('HH:mm')} - {dayjs.utc(item.end_time).format('HH:mm')}</span>) : (
                                                                  <span>{item.start_time} - {item.end_time}</span>)
                                                            }
                                                          </div>

                                                          <div>
                                                            <span className="text-gray-600 dark:text-gray-300">Instituție: </span>
                                                            {item.location?.institution || "Nu exista institutie"}
                                                          </div>

                                                          <div>
                                                            <span className="text-gray-600 dark:text-gray-300">Adresă: </span>
                                                            {item.location?.institution ?
                                                              item.location?.address + " - " + item.location?.city : "Nu exista institutie"
                                                            }
                                                          </div>

                                                          <div>
                                                            <span className="text-gray-600 dark:text-gray-300">Specialitate: </span>
                                                            {item.activity?.speciality || "Nu exista specialitate"}
                                                          </div>

                                                          <div>
                                                            <span className="text-gray-600 dark:text-gray-300">Persoane: </span>
                                                            {item.persons}
                                                          </div>

                                                          <div className="flex justify-end items-center">
                                                            <div className="flex gap-1">
                                                              <div
                                                                className="font-semibold text-center"
                                                                style={{
                                                                  fontWeight: "bold",
                                                                  fontSize: "20px",
                                                                }}
                                                              >
                                                                {
                                                                  item.report_detail_id !== null
                                                                    ? (
                                                                      <div className="flex items-center space-x-2">
                                                                        <Tooltip title={"Raportat"} arrow placement="top">
                                                                          <MdOutlineDoneAll className="text-green-700 text-xl" />
                                                                        </Tooltip>

                                                                        <Tooltip title={"Editeaza"} arrow placement="top">
                                                                          <div
                                                                            onClick={() => setSelecteddeleteuser4(item)}
                                                                            color="primary"
                                                                            sx={{
                                                                              fontSize: "16px",
                                                                              borderRadius: "50%",
                                                                              "&:hover": {
                                                                                backgroundColor: `#a4adad`,
                                                                              },
                                                                            }}
                                                                          >
                                                                            <FaUserEdit className="dark:text-gray-100" />
                                                                          </div>
                                                                        </Tooltip></div>
                                                                    ) : (
                                                                      <div className="flex items-center space-x-2">
                                                                        <Tooltip title={"Neraportat"} arrow placement="top">
                                                                          <MdClose className="text-red-700 text-xl" />
                                                                        </Tooltip>

                                                                        <Tooltip title={"Raporteaza"} arrow placement="top">
                                                                          <div
                                                                            onClick={() => setSelecteddeleteuser2(item)}
                                                                            color="primary"
                                                                            sx={{
                                                                              fontSize: "16px",
                                                                              borderRadius: "50%",
                                                                              "&:hover": {
                                                                                backgroundColor: `#a4adad`,
                                                                              },
                                                                            }}
                                                                          >
                                                                            <FaUserCheck className="dark:text-gray-100" />
                                                                          </div>
                                                                        </Tooltip>
                                                                      </div>
                                                                    )}
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </button>
                                                    </React.Fragment>
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        </table>
                                      </div>
                                    ) : ("")}
                                  </div>
                                )}
                              </div>
                            </td>
                          </tr>
                        )
                        }
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>

              {showUserDropdown && createPortal(
                <div
                  className="fixed w-64 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg z-50"
                  style={{
                    top: dropdownPosition.top,
                    left: dropdownPosition.left
                  }}
                >
                  <div className="p-3">
                    <div className="flex justify-between items-center mb-3">
                      <span className="text-sm font-medium">Selectează utilizatori</span>
                      <div className="flex gap-2">
                        <button
                          onClick={() => setUserFilter(allUsers.map(user => user.user_id))}
                          className="text-xs text-blue-600 dark:text-blue-400 hover:underline"
                        >
                          Toți
                        </button>
                        <button
                          onClick={() => setShowUserDropdown(false)}
                          className="text-xs text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200"
                        >
                          ✕
                        </button>
                      </div>
                    </div>

                    <div className="max-h-48 overflow-y-auto">
                      {allUsers.map((user) => (
                        <label key={user.user_id} className="flex items-center space-x-3 cursor-pointer rounded hover:bg-gray-100 dark:hover:bg-gray-700">
                          <input
                            type="checkbox"
                            checked={userFilter.includes(user.user_id)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setUserFilter(prev => [...prev, user.user_id]);
                              } else {
                                setUserFilter(prev => prev.filter(id => id !== user.user_id));
                              }
                            }}
                            className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 ml-2"
                          />
                          <span className="text-sm flex-1">{user.user_name_surname}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>,
                document.body
              )}

            </div>

            <div className="flex justify-center mt-4">
              <button
                onClick={() => handlePageChange(pagination.currentPage - 1)}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-l-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                disabled={pagination.currentPage === 1}
              >
                Prev
              </button>

              {pagination.currentPage > 3 && (
                <>
                  <button
                    onClick={() => handlePageChange(1)}
                    className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                  >
                    1
                  </button>
                  <span className="px-2">...</span>
                </>
              )}

              {Array.from({ length: Math.min(5, pagination.totalPages) }, (_, index) => {
                const startPage = Math.max(1, pagination.currentPage - 2);
                const page = startPage + index;

                if (page <= pagination.totalPages) {
                  return (
                    <button
                      key={page}
                      onClick={() => handlePageChange(page)}
                      className={`px-4 py-2 text-sm font-medium ${pagination.currentPage === page
                        ? "bg-gray-500 text-white"
                        : "bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                        }`}
                    >
                      {page}
                    </button>
                  );
                }
                return null;
              })}

              {pagination.currentPage < pagination.totalPages - 2 && (
                <>
                  <span className="px-2">...</span>
                  <button
                    onClick={() => handlePageChange(pagination.totalPages)}
                    className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                  >
                    {pagination.totalPages}
                  </button>
                </>
              )}

              <button
                onClick={() => handlePageChange(pagination.currentPage + 1)}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-r-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                disabled={pagination.currentPage === pagination.totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )
      }
    </div >
  );
}

export default DashboardCard24;
